import { Component, Input, OnChanges } from '@angular/core';

@Component({
	selector: 'subscribe-client-btn',
	template: require('./subscribe-client-btn.html'),
	styles: [require('./subscribe-client-btn.scss')]
})
export class SubscribeClientBtnComponent implements OnChanges {
	@Input() status: string;
	@Input() isEmpty: boolean;
	@Input() isDisabled: boolean;
	btnText: string;

	constructor() {}

	ngOnChanges() {
		this.btnText = this.status === 'UNSUBSCRIBED' ? 'Subscribe' : 'Unsubscribe';
		if (this.isEmpty) {
			this.btnText = '';
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/buttons/subscribe-client-btn/subscribe-client-btn.ts